import { TActions } from '../../../../AppModulesWrapper';

import { IExperiments } from '../../../types/reducers/experiments';
import { APPEND_EXPERIMENT } from '../../../actions/experiments';
import {
  competitionExperimentGroups,
  competitionExperimentName,
  servicesCardsTextsExperimentGroups,
  servicesCardsTextsExperimentName,
} from '../../../constants/experiments';

export const defaultState = {
  [servicesCardsTextsExperimentName]: servicesCardsTextsExperimentGroups.default,
  [competitionExperimentName]: competitionExperimentGroups.default,
};

export const experiments = (state: IExperiments = defaultState, action: TActions): IExperiments => {
  switch (action.type) {
    case APPEND_EXPERIMENT:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
